/**
 * @Description:  工具文件入库
 * @Author:       wangyaqiang
 * @Date: 2022-03-22 12:58:05
 * @LastEditors:  wangyaqiang
 * @LastEditTime: 2022-03-22 20:47:36
 */
const requireFunc = require.context('./', true, /Util.js$/);
const requireAll = context => context.keys().map(path => context(path).default);
const AllUtils = requireAll(requireFunc).filter(item => item);
export default {
    install(Vue) {
        for (const utils of AllUtils) {
            Vue.use(utils);
        }
    },
};
